const GroceryStoreShopperInitialText = "Move items that are on the shopping list from the " +
    "grocery shelves to the Shopper Cart.  Click the Check button when you think that all items " +
    "on the list are in the cart."
        
export default GroceryStoreShopperInitialText 
 